import { render, staticRenderFns } from "./ContaOrigemContaDestino.vue?vue&type=template&id=51f49606&"
import script from "./ContaOrigemContaDestino.vue?vue&type=script&lang=js&"
export * from "./ContaOrigemContaDestino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports